import { useLanguage } from "../../../../API/Context/LanguageContext";
import { FRONTEND_ROUTES } from "../../../../ConfigFiles/Routes/frontend_routes";
import { Card, Row, Col, Container } from "react-bootstrap";
import { 
    FaShieldAlt, 
    FaCheckCircle, 
    FaHourglassHalf, 
    FaLockOpen, 
    FaBookMedical, 
    FaChevronRight 
} from "react-icons/fa";
import { VocabVocabVerificationPending as Vocab } from "../../../../ConfigFiles/multilingual/VocabVerificationPending";
import SocialFooter from "../../General/LandingPage/SocialFooter/SocialFooter";
import { Link } from "react-router-dom"; 


const VerificationPending = () => {
    const { lan } = useLanguage();

    return (
        <Container className="d-flex align-items-center justify-content-center vh-100 bg-light p-3">
            <Card className="shadow-lg border-0 rounded-4 overflow-hidden" style={{ maxWidth: "650px" }}>
                
                <Card.Body className="p-4 p-md-5 text-center">
                    {/* Header Section */}
                    <div className="mb-4">
                        <div className="d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary rounded-circle mb-3" style={{ width: "70px", height: "70px" }}>
                            <FaShieldAlt style={{ fontSize: "2rem" }} />
                        </div>
                        <h2 className="fw-bold text-dark mb-2">{Vocab.pro_pending_title[lan]}</h2>
                        <p className="text-muted small px-md-3">
                            {Vocab.pro_pending_description[lan]}
                        </p>
                    </div>

                    {/* Stepped Progress Bar */}
                    <div className="position-relative mb-5 mt-4 px-4">
                        {/* The Connector Line */}
                        <div className="position-absolute top-50 start-0 end-0 translate-middle-y mx-5" 
                             style={{ height: '2px', background: '#e9ecef', zIndex: 0 }}>
                            <div style={{ width: '50%', height: '100%', background: '#198754' }}></div> {/* Green progress to Step 2 */}
                        </div>

                        <Row className="position-relative" style={{ zIndex: 1 }}>
                            {/* Step 1: Completed */}
                            <Col className="text-center">
                                <div className="bg-success text-white rounded-circle d-inline-flex align-items-center justify-content-center shadow-sm" style={{ width: '32px', height: '32px' }}>
                                    <FaCheckCircle size={18} />
                                </div>
                                <div className="extra-small fw-bold mt-2 text-success" style={{ fontSize: '0.65rem' }}>{Vocab.step_data_captured[lan]}</div>
                            </Col>

                            {/* Step 2: Current (Warning/Pending) */}
                            <Col className="text-center">
                                <div className="bg-warning text-white rounded-circle d-inline-flex align-items-center justify-content-center shadow-sm" style={{ width: '32px', height: '32px', border: '4px solid #fff' }}>
                                    <FaHourglassHalf size={14} />
                                </div>
                                <div className="extra-small fw-bold mt-2 text-warning" style={{ fontSize: '0.65rem' }}>{Vocab.status_pending[lan]}</div>
                            </Col>

                            {/* Step 3: Future */}
                            <Col className="text-center">
                                <div className="bg-white text-muted border rounded-circle d-inline-flex align-items-center justify-content-center shadow-sm" style={{ width: '32px', height: '32px' }}>
                                    <FaLockOpen size={14} />
                                </div>
                                <div className="extra-small fw-bold mt-2 text-muted" style={{ fontSize: '0.65rem' }}>{Vocab.step_ready[lan]}</div>
                            </Col>
                        </Row>
                    </div>

                    {/* Safety/Legal Badge */}
                    <div className="alert alert-info border-0 rounded-3 py-2 px-3 mb-4 d-inline-flex align-items-center w-100 shadow-sm">
                        <span className="text-start text-dark" style={{ fontSize: '0.8rem' }}>
                            <FaShieldAlt className="text-primary me-2" />
                            {Vocab.safety_compliance_note[lan]}
                        </span>
                    </div>

                    {/* Manual CTA */}
                    <div className="border rounded-4 p-3 mb-2 text-start bg-white shadow-sm border-primary border-opacity-25">
                        <div className="d-flex align-items-center">
                            <div className="bg-primary bg-opacity-10 p-2 rounded-3 me-3 text-primary">
                                <FaBookMedical size={24} />
                            </div>
                            <div className="flex-grow-1">
                                <h6 className="fw-bold mb-1 small">{Vocab.prepare_yourself[lan]}</h6>
                                <p className="extra-small text-muted mb-0" style={{ lineHeight: '1.3', fontSize: '0.75rem' }}>
                                    {Vocab.manual_intro[lan]}
                                </p>
                            </div>
                            <Link to={FRONTEND_ROUTES.professionals_manual} className="btn btn-sm btn-primary rounded-pill px-2 ms-2 flex-shrink-0">
                                <FaChevronRight size={12} />
                            </Link>
                        </div>
                    </div>
                </Card.Body>

                <Card.Footer className="bg-white border-0 pb-5 px-5">
                    <SocialFooter />
                </Card.Footer>
            </Card>
        </Container>
    );
};

export default VerificationPending;